export default {
  'fields.name.captcha': '验证码',
  'fields.name.password': '登录密码',
  'fields.name.paypass': '支付密码',
  'fields.name.oldpassword': '原登录密码',
  'fields.name.newpassword': '新登录密码',
  'fields.name.confirmpassword': '再次确认登录密码',
  'fields.error.newpassword.confirmpassword': '请确认新登录密码是否一致！',
  'fields.name.oldpaypass': '原支付密码',
  'fields.name.newpaypass': '新支付密码',
  'fields.name.confirmpaypass': '再次确认支付密码',
  'fields.error.newpaypass.confirmpaypass': '请确认新支付密码是否一致！',
};